// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "main.465d8bc6.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"2692":"38984c30","7147":"2e44e241","8983":"2780463c"}[chunkId] + ".chunk.css";
};